import { useDebounceFn } from '@vueuse/core';

export default (value: Ref<string | undefined>) => {
  const copied = ref(false);
  const copyValue = ref(value.value);

  watch(value, (currentValue) => {
    copyValue.value = currentValue;
  });

  const copy = useDebounceFn(async () => {
    if (!navigator.clipboard || !copyValue.value) {
      return;
    }

    try {
      await navigator.clipboard.writeText(copyValue.value);
      copied.value = true;
    } catch (err) {
      console.log(err);
    } finally {
      setTimeout(() => {
        copied.value = false;
      }, 2000);
    }
  });

  return { copied, copy };
};
